"use strict";

angular.module("core")
.directive("invoiceItem", function() {
    return {
        restrict: "E",
        controllerAs: "invoiceItemCtrl",
        templateUrl: require("./invoice-item.directive.html"),
        scope: true,
        bindToController: {
            invoice: "<",
            invoiceItems: "<",
            isReturn: "<"
        },
        controller: function($scope, IS_MOBILE) {
            $scope.isMobile = IS_MOBILE;
            $scope.isReturn = this.isReturn;

            $scope.totalSalesUnitOfMeasure = "";
            $scope.totalReturnsUnitOfMeasure = "";
            if (this.invoice.enable_product_measure_management) {
                $scope.totalSalesUnitOfMeasure = joinUnitsOfMeasure(this.invoice.total_sales_units_of_measure);
                $scope.totalReturnsUnitOfMeasure = joinUnitsOfMeasure(this.invoice.total_returns_units_of_measure);
            }

            this.getLength = function(columns) {
                if (typeof columns !== "undefined") {
                    return Object.keys(columns).length;
                }
            };

            this.getItemNameColSpan = function() {
                var colSpan = 6;
                if (this.invoice.TaxResult.taxes) {
                    colSpan += Object.keys(this.invoice.TaxResult.taxes).length;
                }
                if (this.invoice.TaxResult.other_charges) {
                    colSpan += Object.keys(this.invoice.TaxResult.other_charges).length;
                }
                if (!$scope.isReturn && this.invoice.rebate > 0) {
                    colSpan += 1;
                }
                return colSpan;
            };

            function joinUnitsOfMeasure(totalUnitsOfMeasure) {
                if (typeof totalUnitsOfMeasure !== "object" || totalUnitsOfMeasure === null) {
                    return '';
                }
                else {
                    return _.map(totalUnitsOfMeasure, function(value, code) {
                        return value + " " + code
                    }).join(" / ") + " / ";
                }
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-item/invoice-item.directive.js
// module id = 505
// module chunks = 0